<template>
    <div v-if="form">
        <b-card class="m-0" no-body>
            <b-card-header class="d-flex justify-content-between align-items-center">
                <h5 v-if="isEdit" class="modal-title">Edit Nota Supplier</h5>
                <h5 v-else class="modal-title">{{ isKonfirmasi ? 'Konfirmasi' : (form.id ? 'Informasi' : 'Create') }} Nota Supplier</h5>
            </b-card-header>
            <b-card-body>
                <viewer v-if="isKonfirmasi || viewMode" :value="form"></viewer>
                <div v-show="!isKonfirmasi && !viewMode" class="table-responsive">
                    <table class="table table-borderless mb-3" v-if="grades">
                        <tr>
                            <th class="fit-column">Grade</th>
                            <th>Harga Per Kg</th>
                        </tr>
                        <tr v-for="grade in grades">
                            <th class="fit-column text-center text-primary">{{ grade.grade.name }}</th>
                            <th>
                                <input v-validate="'min_value:0'" min="0" v-model="grade.harga" type="number" class="form-control" @input="updateDetailsHarga(grade.grade.id, $event.target.value)">
                            </th>
                        </tr>
                    </table>
                    <table class="table table-borderless">
                        <tr>
                            <th class="fit-column">Supplier</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ form.supplier ? form.supplier.name : '-' }}</th>
                        </tr>
                        <tr v-if="form.created_at">
                            <th class="fit-column">Tanggal</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ formatDate(form.created_at) }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Berat Total</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary" v-if="!form.id || detailLoaded">{{ form ? formatNumber(beratTotal) + ' Kg' : '-' }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Sub Total</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary" v-if="!form.id || detailLoaded">{{ form ? formatNumber(subTotal) : '-' }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column text-warning">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" v-model="form.bonus_status">
                                    <label class="form-check-label" for="defaultCheck1">
                                        Bonus (+)
                                    </label>
                                </div>
                            </th>
                            <td class="fit-column">:</td>
                            <td class="text-warning">
                                <div class="input-group" v-show="form.bonus_status">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1">Rp</span>
                                    </div>
                                    <input v-validate="'min_value:0'" min="0" v-model="form.bonus" type="number" name="bonus" class="form-control">
                                </div>
                                <span class="text-danger">{{ errors.first('bonus') }}</span>
                            </td>
                        </tr>
                        <tr>
                            <th class="fit-column text-info">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" v-model="form.pengurang_status">
                                    <label class="form-check-label" for="defaultCheck1">
                                        Pengurang (-)
                                    </label>
                                </div>
                            </th>
                            <td class="fit-column">:</td>
                            <td class="text-info">
                                <div class="input-group" v-show="form.pengurang_status">
                                    <input v-validate="'min_value:0|max_value:100'" min="0" max="100" v-model="form.pengurang" type="number" name="pengurang" class="form-control">
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="basic-addon1">%</span>
                                    </div>
                                </div>
                                <span class="text-danger">{{ errors.first('pengurang') }}</span>
                            </td>
                        </tr>
                        <tr>
                            <th class="fit-column">Berat Akhir</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary" v-if="!form.id || detailLoaded">{{ form ? formatNumber(beratAkhir) + ' Kg' : '-' }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column text-info">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" v-model="form.pajak_status">
                                    <label class="form-check-label" for="defaultCheck1">
                                        Pajak (-)
                                    </label>
                                </div>
                            </th>
                            <td class="fit-column">:</td>
                            <td class="text-info">
                                <div class="input-group" v-show="form.pajak_status">
                                    <input v-validate="'min_value:0|max_value:100'" min="0" max="100" v-model="form.pajak" type="number" name="pajak" class="form-control">
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="basic-addon1">%</span>
                                    </div>
                                </div>
                                <span class="text-danger">{{ errors.first('pajak') }}</span>
                            </td>
                        </tr>
                        <tr>
                            <th class="fit-column text-info">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" v-model="form.admin_status">
                                    <label class="form-check-label" for="defaultCheck1">
                                        Admin (-)
                                    </label>
                                </div>
                            </th>
                            <td class="fit-column">:</td>
                            <td class="text-info">
                                <div class="input-group" v-show="form.admin_status">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1">Rp</span>
                                    </div>
                                    <input v-show="form.admin_status" v-validate="'min_value:0'" min="0" v-model="form.admin" type="number" name="admin" class="form-control">
                                </div>
                                <span class="text-danger">{{ errors.first('admin') }}</span>
                            </td>
                        </tr>
                        <tr>
                            <th class="fit-column text-info">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" v-model="form.potongan_status">
                                    <label class="form-check-label" for="defaultCheck1">
                                        Potongan (-)
                                    </label>
                                </div>
                            </th>
                            <td class="fit-column">:</td>
                            <td class="text-info">
                                <input v-show="form.potongan_status" v-model="form.potongan_notes" type="text" placeholder="Keterangan" name="potongan_notes" class="form-control">
                            </td>
                        </tr>
                        <tr v-show="(form && form.potongan_notes) || (form && form.potongan_status)">
                            <th></th>
                            <td></td>
                            <td class="text-info">
                                <div class="input-group" v-show="form.potongan_status">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1">Rp</span>
                                    </div>
                                    <input v-show="form.potongan_status" v-validate="'min_value:0'" min="0" v-model="form.potongan" type="number" name="potongan" class="form-control">
                                </div>
                                <span class="text-danger">{{ errors.first('potongan') }}</span>
                            </td>
                        </tr>
                        <tr>
                            <th class="fit-column">Total Pembayaran</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary" v-if="!form.id || detailLoaded">{{ form ? formatNumber(totalPembayaran) : '-' }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Metode Pembayaran</th>
                            <td class="fit-column">:</td>
                            <td>
                                <div class="input-group single mb-0 d-flex">
                                    <multiselect class='w-auto flex-grow-1' v-validate="'required'" name="metode_pembayaran" v-model="form.metode_pembayaran" :options="metodeOptions" :placeholder="'Pilih'" :searchable="true"
                                        label="value" track-by="name" :allowEmpty="false" :show-labels="false"></multiselect>
                                </div>
                                <span class="text-danger">{{ errors.first('metode_pembayaran') }}</span>
                            </td>
                        </tr>
                    </table>
                </div>

                <detail :isEdit="isEdit && !isKonfirmasi" :value="form" @loaded="loadedDetails" @update-details="updatePembelians"></detail>
            </b-card-body>
            <b-card-footer class="d-flex flex-row-reverse">
                <template v-if="!isEdit && !form.id">
                    <button :disabled="isLoading" v-if="!isKonfirmasi" @click="$emit('cancel')" type="button" class="btn btn-secondary" data-dismiss="modal">Batal</button>
                    <button :disabled="isLoading" v-if="isKonfirmasi" @click="koreksi" type="button" class="btn btn-secondary">Koreksi</button>
                    <button :disabled="isLoading" v-if="isKonfirmasi" @click="save(true)" type="button" class="btn btn-primary mr-2"><i class="fas fa-print"></i> Print</button>
                    <button :disabled="isLoading" v-if="!isKonfirmasi" @click="konfirmasi" type="button" class="btn btn-primary mr-2">Buat</button>
                </template>
                <template v-if="viewMode">
                    <button :disabled="isLoading" @click="$emit('cancel')" type="button" class="btn btn-secondary" data-dismiss="modal">Kembali</button>
                    <button :disabled="isLoading" @click="print(form.id)" type="button" class="btn btn-primary mr-2"><i class="fas fa-print"></i> Print</button>
                    <button :disabled="isLoading" @click="exportExcel(form.id)" type="button" class="btn btn-primary mr-2"><i class="fa fa-file-excel"></i> Export</button>
                </template>
                <template v-if="isEdit">
                    <button :disabled="isLoading" @click="$emit('cancel')" type="button" class="btn btn-secondary" data-dismiss="modal">Batal</button>
                    <button :disabled="isLoading" @click="save(false)" type="button" class="btn btn-primary mr-2">Simpan</button>
                </template>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
import Detail from './Detail';
import Viewer from './Viewer';
import ExportMixin from '../../mixin/export';
import Multiselect from 'vue-multiselect';

export default {
    name: "nota-supplier-form",

    props: {
        value: {
            type: Object,
            default: () => {},
        },

        isEdit: {
            type: Boolean,
            default: false,
        },
    },

    components: {
        Detail,
        Viewer,
        Multiselect,
    },

    mixins: [ExportMixin],

    data() {
        return {
            form: null,
            isKonfirmasi: false,
            detailLoaded: false,
            grades: [],
            hargaEdits: [],
            metodeOptions: [
                {
                    name: 'tunai',
                    value: 'Tunai',
                },
                {
                    name: 'transfer',
                    value: 'Transfer',
                },
            ],
            exportUrl: '/export/nota-suppliers',
        }
    },

    created() {
    },

    mounted() {
        if (this.value) {
            this.initForm();
        }
    },

    computed: {
        beratTotal() {
            let berat_total = 0;
            this.form.pembelians.forEach(pembelian => {
                berat_total += pembelian.pembayaran_supplier.berat_akhir;
            });

            return berat_total;
        },

        subTotal() {
            let sub_total = 0;
            this.form.pembelians.forEach((pembelian, index) => {
                let harga = this.isEdit ? this.hargaEdits[index] : pembelian.harga;
                sub_total += (parseInt(harga) * pembelian.pembayaran_supplier.berat_akhir);
            });

            return sub_total;
        },

        beratAkhir() {
            let berat_pengurang = this.form.pengurang_status ? parseInt(Math.ceil(this.beratTotal * (this.form.pengurang || 0) / 100)) : 0;

            return this.beratTotal - berat_pengurang;
        },

        totalPembayaran() {
            let total = this.subTotal;

            if (this.form.pajak_status) {
                total -= parseInt(Math.floor((this.form.pajak || 0) * total / 100));
            }
            if (this.form.bonus_status) {
                total += parseInt(this.form.bonus || 0);
            }
            if (this.form.admin_status) {
                total -= this.form.admin || 0;
            }
            if (this.form.potongan_status) {
                total -= this.form.potongan || 0;
            }

            return total;
        },

        viewMode() {
            return !this.isEdit && this.form.id;
        },
    },

    watch: {
        value() {
            this.initForm();
        },
    },

    methods: {
        initForm() {
            let self = this;

            if (self.value) {
                self.form = Object.assign({}, self.value);
                if (self.form.id) {
                    self.form.pembelians = Object.assign([], self.form.items.map((item) => item.pembayaran_supplier.pembelian_tembakau));
                }
                let metodeIndex = self.metodeOptions.findIndex(option => option.name == self.value.metode_pembayaran);
                self.form.metode_pembayaran = Object.assign({}, self.metodeOptions[metodeIndex]);
            }
            self.setGrades();
        },

        print(id) {
            let self = this;

            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            newIframe.src = '/nota-suppliers/print/'+id;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
                self.$emit('cancel');
            }
        },

        koreksi() {
            this.isKonfirmasi = false;
        },

        konfirmasi() {
            let self = this;

            self.$validator.validateAll().then(result => {
                if (result) {
                    self.form.sub_total = self.subTotal;
                    self.form.berat_total = self.beratTotal;
                    self.form.berat_akhir = self.beratAkhir;
                    self.form.total = self.totalPembayaran;
                    self.isKonfirmasi = true;
                }
            });
        },

        save(isPrint) {
            let self = this,
                data = Object.assign({}, {
                    supplier_id: self.form.supplier.id,
                    bonus: self.form.bonus,
                    bonus_status: self.form.bonus_status,
                    pengurang: self.form.pengurang,
                    pengurang_status: self.form.pengurang_status,
                    pajak: self.form.pajak,
                    pajak_status: self.form.pajak_status,
                    admin: self.form.admin,
                    admin_status: self.form.admin_status,
                    potongan: self.form.potongan,
                    potongan_notes: self.form.potongan_notes,
                    potongan_status: self.form.potongan_status,
                    pembayaran_supplier_ids: self.form.pembelians.map(pembelian => pembelian.pembayaran_supplier.id),
                    pembayaran_supplier_hargas: self.form.pembelians.map(pembelian => pembelian.harga),
                    sub_total: self.subTotal,
                    total: self.totalPembayaran,
                    berat_total: self.beratTotal,
                    berat_akhir: self.beratAkhir,
                    metode_pembayaran: self.form.metode_pembayaran.name,
                });

            self.isLoading = true;
            let api = self.isEdit ? '/api/nota-suppliers/'+self.form.id : '/api/nota-suppliers';

            self.$Progress.start();
            axios({
                method: self.isEdit ? 'put' : 'post',
                url: api,
                data: data
            })
            .then(function (response) {
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
                self.isLoading = false;
                self.$Progress.finish();
                self.$emit('saved', response.data.data);
                if (isPrint) {
                    self.print(response.data.data.id);
                }
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },

        loadedDetails(pembelians) {
            this.form.pembelians = Object.assign([], pembelians);
            this.setGrades();
            this.detailLoaded = true;
        },

        setGrades() {
            this.form.pembelians.forEach(pembelian => {
                let foundIndex = this.grades.findIndex((grade) => grade.grade && grade.grade.id == pembelian.grade.id);
                let harga = pembelian.pembayaran_supplier.nota_supplier_item ? pembelian.pembayaran_supplier.nota_supplier_item.harga : pembelian.harga;
                if (foundIndex < 0) {
                    this.grades.push({
                        grade: Object.assign({}, pembelian.grade),
                        harga: harga,
                    });
                }
                if (foundIndex > -1 && this.grades[foundIndex].harga != harga) {
                    this.grades[foundIndex].harga = null;
                }
            });
            this.grades.sort((a, b) => {
                if (a.grade.name < b.grade.name) {
                    return -1;
                }
                if (a.grade.name > b.grade.name) {
                    return 1;
                }
                return 0;
            });
        },

        updatePembelians(pembelians) {
            this.form.pembelians = Object.assign([], pembelians);
            this.detailLoaded = true;
            if (this.isEdit) {
                this.hargaEdits = this.form.pembelians.map((pembelian) => pembelian.harga);
            }
        },

        updateDetailsHarga(id, harga) {
            this.form.pembelians.forEach((pembelian, index) => {
                console.log(pembelian);
                if (pembelian.grade.id == id) {
                    this.form.pembelians[index].harga = harga ? harga : (pembelian.pembayaran_supplier.nota_supplier_item ? pembelian.pembayaran_supplier.nota_supplier_item.harga : pembelian.pembayaran_supplier.harga_per_kg);
                }
            });
            this.updatePembelians(this.form.pembelians);
        },
    },
}
</script>
<style>
.fit-column {
    width: 0.1%;
    white-space: nowrap;
}

th, td {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
}
</style>
